import { Environment } from './environment.model';

export const environment: Environment = {
  //   apiUrl: 'http://localhost:3000/',
  apiUrl: 'https://api.chefi.stoaproductgroup.cloud/',
  production: false,
};
